import MarkdownRenderer from '@/components/MarkdownRenderer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
const PracticeQuestionExplanation = ({
  explanation,
  defaultExpanded
}: {
  explanation: string;
  defaultExpanded: boolean;
}) => {
  return <Box mt={4} data-sentry-element="Box" data-sentry-component="PracticeQuestionExplanation" data-sentry-source-file="PracticeQuestionExplanation.tsx">
      <Accordion defaultExpanded={defaultExpanded} sx={{
      borderRadius: 2,
      boxShadow: 2,
      backgroundColor: 'white'
    }} data-sentry-element="Accordion" data-sentry-source-file="PracticeQuestionExplanation.tsx">
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" data-sentry-element="AccordionSummary" data-sentry-source-file="PracticeQuestionExplanation.tsx">
          <Typography component="span" sx={{
          fontWeight: 'bold'
        }} data-sentry-element="Typography" data-sentry-source-file="PracticeQuestionExplanation.tsx">
            Explanation
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{
        backgroundColor: 'white',
        borderRadius: 1,
        padding: 2,
        boxShadow: 3 // Try 3 to 6 for deeper shadow
      }} data-sentry-element="AccordionDetails" data-sentry-source-file="PracticeQuestionExplanation.tsx">
          <MarkdownRenderer content={explanation} data-sentry-element="MarkdownRenderer" data-sentry-source-file="PracticeQuestionExplanation.tsx" />
        </AccordionDetails>
      </Accordion>
    </Box>;
};
export default PracticeQuestionExplanation;